// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const FormatAlignLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="nonzero"
      d="M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"
    />
  </svg>
);

export default FormatAlignLeft;
